import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { LoginService } from '../services/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'qmed-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class LoginComponent implements OnInit {
  login: FormGroup;
  invalidLogin: boolean;
  constructor(private loginService: LoginService, private router: Router) {}

  ngOnInit() {
    this.invalidLogin = false;
    this.login = new FormGroup({
      username: new FormControl(),
      password: new FormControl()
    });
  }

  onSubmit({ value, valid }: { value: any; valid: boolean }) {
    this.loginService.login(value.username, value.password).subscribe(
      r => {} ,
      e => this.invalidLogin = this.loginService.isInvalidLogin());
  }
}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/login/login.component.ts